// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Jd","heading":"Kd"};